import { render, staticRenderFns } from "./JoinOrNewLOD.vue?vue&type=template&id=3a15e3aa&scoped=true"
import script from "./JoinOrNewLOD.vue?vue&type=script&lang=js"
export * from "./JoinOrNewLOD.vue?vue&type=script&lang=js"
import style0 from "./JoinOrNewLOD.vue?vue&type=style&index=0&id=3a15e3aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a15e3aa",
  null
  
)

export default component.exports